module.exports = __webpack_public_path__ + "static/media/corego-logo.129da563.png";